import {
  DocumentIcon,
  PDFIcon,
  PPTDocIcon,
  WordDocIcon,
  XLSDocIcon,
  ZIPDocIcon,
  JPGDocIcon,
  HTMLDocIcon
} from './Icons'

type Props = {
  fileName: string
  color?:
    | 'primary'
    | 'inherit'
    | 'action'
    | 'disabled'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | undefined
}
export default function IconExtension(props: Props): JSX.Element {
  const { fileName, color = 'primary' } = props

  if (fileName.toLocaleLowerCase().endsWith('.pdf')) {
    return <PDFIcon color={color} />
  }

  if (
    fileName.toLocaleLowerCase().endsWith('.docx') ||
    fileName.toLocaleLowerCase().endsWith('.doc')
  ) {
    return <WordDocIcon color={color} />
  }

  if (
    fileName.toLocaleLowerCase().endsWith('.pptx') ||
    fileName.toLocaleLowerCase().endsWith('.ppt')
  ) {
    return <PPTDocIcon color={color} />
  }

  if (
    fileName.toLocaleLowerCase().endsWith('.zip') ||
    fileName.toLocaleLowerCase().endsWith('.rar')
  ) {
    return <ZIPDocIcon color={color} />
  }

  if (
    fileName.toLocaleLowerCase().endsWith('.jpg') ||
    fileName.toLocaleLowerCase().endsWith('.jpeg')
  ) {
    return <JPGDocIcon color={color} />
  }

  if (
    fileName.toLocaleLowerCase().endsWith('.xlsx') ||
    fileName.toLocaleLowerCase().endsWith('.xls')
  ) {
    return <XLSDocIcon color={color} />
  }

  if (
    fileName.toLocaleLowerCase().endsWith('.html') ||
    fileName.toLocaleLowerCase().endsWith('.htm')
  ) {
    return <HTMLDocIcon color={color} />
  }

  return <DocumentIcon color={color} />
}
